import React from 'react';

const Location = () => {
    // Replace this placeholder with your official Google Maps Share / Embed URL link
    const embedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.601007886221!2d-96.54299222342502!3d32.9323459746401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c03a3ed93e887%3A0x6a0003c6df8e5c21!2sEmbrace%20Beauty%20Aesthetics!5e0!3m2!1sen!2sus!4v1718000000000!5m2!1sen!2sus";

    const styles = {
        section: {
            padding: '60px 20px',
            backgroundColor: '#faf8f5',
            textAlign: 'center',
        },
        container: {
            maxWidth: '1140px',
            margin: '0 auto',
        },
        heading: {
            fontSize: '32px',
            color: '#222222',
            marginBottom: '10px',
            fontFamily: 'sans-serif'
        },

        subtext: {
            fontSize: '16px',
            color: '#666666',
            marginBottom: '30px',
        },
        mapWrapper: {
            position: 'relative',

            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            width: '100%',
            height: '450px',
        },
        iframe: {
            border: '0',
            width: '100%',
            height: '100%',
        }
    };

    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <h2 style={styles.heading}>Our Location</h2>
                <p style={styles.subtext}>
                    8200 Liberty Grove Rd Suite #103, Rowlett, TX 75089, United States
                </p>

                <div style={styles.mapWrapper}>
                    <iframe
                        src={embedUrl}
                        style={styles.iframe}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Embrace Beauty Aesthetics Location Map"
                    ></iframe>
                </div>
            </div>
        </section>
    );
};

export default Location;
